import { Drawable } from "./drawable";
import { ScreenState } from "./screen";
import { fadeRGB, rgb, rgba } from "../utils/color";
import { easeOutExpo, easeOutQuint, easeOutSine } from "easing-utils";
import RenderableSegmentationMask from './segmentationMask'
import { easeInCubic } from "easing-utils";
export class PointsCounter extends Drawable{
  takesSegmentationMask = true;
  currentPlayerPosition = null;// not in use anymore, to remove.
  score = 0;
  combo = 0;
  /**
  * Initialiases the Dummy drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */
  constructor(noteIcon, songTitle, songArtist, songDifficulty, duration, currentPlayerPosition, segmentationColoursData, configureCanvas){
    super(undefined, undefined, configureCanvas);
    this.noteIcon = noteIcon;
    this.songTitle = songTitle;
    this.songArtist = songArtist;
    this.songDifficulty = songDifficulty;
    this.duration = duration;
    this.initialPlayerPosition = currentPlayerPosition;
    this.segmentationColoursData = segmentationColoursData
  }

  /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  configure(screenState){
  }

  /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  * @param {RenderableSegmentationMask | undefined} segmentationMask The segmentation mask of the user if avaliable.
  */
  render(screenState, segmentationMask) {
    super.render(screenState);
    if(!this.initialScreenStateTime && this.duration){
      this.initialScreenStateTime = screenState.animationStep;
    }
    // if (this.initialScreenStateTime){
    //   this.currentPlayerPosition = this.initialPlayerPosition + (screenState.animationStep - this.initialScreenStateTime);
    // }
    
    // Prevent music seek from reseting after music finish. 

    const timeSinceInit = screenState.animationStep - this.initTime;
    if (timeSinceInit < 3000){
      this.currentPlayerPosition = 0;
    }
    else if (timeSinceInit > 10000){
      this.currentPlayerPosition = screenState.playerPosition || this.duration// (screenState.animationStep - this.initTime > this.duration*0.75) ? this.duration : 0;
    }
    else{
      this.currentPlayerPosition = screenState.playerPosition || 0// (screenState.animationStep - this.initTime > this.duration*0.75) ? this.duration : 0;
    }

    // Background
    screenState.canvasCtx.fillStyle = rgb(0,0,0);
    if (screenState.transitionProgress < 1){
      const transitionProgress = easeOutQuint(screenState.transitionProgress);
      const halfOfScreenHeight = screenState.height/2*transitionProgress;
      screenState.canvasCtx.globalAlpha = transitionProgress;
      screenState.canvasCtx.fillRect(screenState.offsetX, screenState.offsetY, screenState.width, halfOfScreenHeight);
      screenState.canvasCtx.fillRect(screenState.offsetX, screenState.offsetY + screenState.height-halfOfScreenHeight, screenState.width, halfOfScreenHeight);
    }
    else{
      screenState.canvasCtx.globalAlpha = 1;
      screenState.canvasCtx.fillRect(screenState.offsetX, screenState.offsetY, screenState.width, screenState.height);
    }

    // Segmentation Mask
    if (segmentationMask){
      if (this.segmentationColoursData && Object.keys(this.segmentationColoursData).length > 0 && this.segmentationColoursData["0"]){
        if (Object.keys(this.segmentationColoursData).length == 1){
          const maskColour = this.segmentationColoursData["0"]
          segmentationMask.recolor_mask(maskColour.r, maskColour.g, maskColour.b, screenState.transitionProgress);
          segmentationMask.render(screenState);
        }
        else{
          if (!this.prevSegmentationMaskColor){
            this.prevSegmentationMaskColor = this.segmentationColoursData["0"]
          }
          if (!this.currentSegmentationMaskColorTime || this.currentSegmentationMaskColorTime < this.currentPlayerPosition){
            if (this.currentSegmentationMaskColorTime){
              this.prevSegmentationMaskColor = this.segmentationColoursData[this.currentSegmentationMaskColorTime.toString()]
            }
            const segmentationMaskColorTimings = Object.keys(this.segmentationColoursData).map(Number).sort((a,b) => (a-b))
            for (let i = 0; i < segmentationMaskColorTimings.length; i++){
              if (segmentationMaskColorTimings[i] >= this.currentPlayerPosition || i+1 == segmentationMaskColorTimings.length){
                this.currentSegmentationMaskColorTime = segmentationMaskColorTimings[i];
                break;
              }
            }
          }
          const newMaskColour = this.segmentationColoursData[this.currentSegmentationMaskColorTime.toString()];
          const transitionAmount = 1-(Math.min(this.currentSegmentationMaskColorTime - this.currentPlayerPosition, 500)/500);
          const finalMaskColour = fadeRGB(this.prevSegmentationMaskColor.r, this.prevSegmentationMaskColor.g, this.prevSegmentationMaskColor.b, newMaskColour.r, newMaskColour.g, newMaskColour.b, easeOutSine(Math.min(transitionAmount, 1)))
          segmentationMask.recolor_mask(...finalMaskColour, screenState.transitionProgress);
          segmentationMask.render(screenState);
        }
      }
      else{
        segmentationMask.recolor_mask(108, 212, 255, screenState.transitionProgress);
        segmentationMask.render(screenState);
      }
    }
    

    // Intro Text & Countdown
    if (timeSinceInit <= 4000){
      screenState.canvasCtx.globalAlpha = timeSinceInit > 3000 ? 1-((timeSinceInit - 3000)/1000) : 1;
      screenState.canvasCtx.fillStyle = rgba(255,255,255,1);
      screenState.canvasCtx.font = `bold ${screenState.S(45)}px Yusei Magic`;
      screenState.canvasCtx.textAlign = 'center';
      screenState.canvasCtx.textBaseline = 'middle';
      const [introTxtXpos, introTxtYpos] = [screenState.X(710), screenState.Y(294)]
      const iconSize = screenState.S(75);
      const txtBounding = screenState.canvasCtx.measureText(this.songTitle);
      const txtHeight = txtBounding.actualBoundingBoxAscent + txtBounding.actualBoundingBoxDescent;
      this.noteIcon.render(screenState.canvasCtx, introTxtXpos, introTxtYpos - txtHeight - iconSize/2, iconSize, iconSize, rgb(255,255, 255));
      screenState.canvasCtx.fillText(this.songTitle, introTxtXpos, introTxtYpos);
      screenState.canvasCtx.font = `${screenState.S(28)}px Yusei Magic`;
      const txtBounding2 = screenState.canvasCtx.measureText(this.songArtist);
      const txtHeight2 = txtBounding2.actualBoundingBoxAscent + txtBounding2.actualBoundingBoxDescent;
      screenState.canvasCtx.fillStyle = rgba(255,255, 255, screenState.transitionProgress);
      screenState.canvasCtx.fillText(this.songArtist, introTxtXpos, introTxtYpos + txtHeight + 10);
      screenState.canvasCtx.fillText(this.songDifficulty, introTxtXpos, introTxtYpos + txtHeight + txtHeight2 + 20);
      
      if (timeSinceInit > 1000){
        screenState.canvasCtx.globalAlpha = 1;
        screenState.canvasCtx.textBaseline = 'top';
        screenState.canvasCtx.font = `${screenState.S(72)}px Yusei Magic`;
        screenState.canvasCtx.fillText(Math.ceil((4000 - timeSinceInit)/1000).toString(), screenState.X(710), screenState.Y(365) + txtHeight + txtHeight2)
      }
    }

    let transitionProgress;
    if (this.outroTimestamp){
      if (this.outroTimestamp === true){
        this.outroTimestamp = screenState.animationStep;
      }
      transitionProgress = easeInCubic(Math.max(1-(screenState.animationStep - this.outroTimestamp)/1000, 0));
    }
    else{
      transitionProgress = screenState.transitionProgress;
    }
    screenState.canvasCtx.globalAlpha = transitionProgress;
    screenState.canvasCtx.font = `${screenState.S(48)}px Yusei Magic`;
    const scoreText = this.score.toString().padStart(6, "0");
    const comboText = this.combo.toString().padStart(2, "0");
    const finalScoreWidth = screenState.canvasCtx.measureText(scoreText).width + screenState.S(100);
    const scoreBoxHeight = screenState.Y(150) - screenState.offsetY;
    const finalComboWidth = screenState.canvasCtx.measureText(comboText).width + screenState.S(50);
    const comboBoxHeight = Math.max(screenState.Y(150) - screenState.offsetY, finalComboWidth);
    // const progressWidth = screenState.width - finalScoreWidth*0.75 - finalComboWidth*0.75;
    // const progressHeight =  screenState.S(75);
    screenState.canvasCtx.fillStyle = rgb(108, 212, 255);
    screenState.canvasCtx.strokeStyle = rgb(228, 255, 26);
    screenState.canvasCtx.shadowColor = rgb(228, 255, 26);
    screenState.canvasCtx.lineWidth = 5;
    screenState.canvasCtx.shadowBlur = 15;
    
    // // Progress Bar
    // const progressXpos = screenState.offsetX + finalScoreWidth*0.75;
    // screenState.canvasCtx.beginPath();
    // screenState.canvasCtx.rect(progressXpos, screenState.offsetY, progressWidth, progressHeight);
    // screenState.canvasCtx.fill();
    // screenState.canvasCtx.beginPath();
    // screenState.canvasCtx.moveTo(progressXpos, screenState.offsetY + progressHeight);
    // screenState.canvasCtx.lineTo(progressXpos + progressWidth, screenState.offsetY + progressHeight);
    // screenState.canvasCtx.stroke();
    
    // Score box
    const scoreYpos = screenState.Y(150);
    const scoreXpos = screenState.offsetX;
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.moveTo(scoreXpos, scoreYpos);
    screenState.canvasCtx.lineTo(finalScoreWidth - scoreBoxHeight + screenState.offsetX, scoreYpos)
    screenState.canvasCtx.arc(finalScoreWidth - scoreBoxHeight, screenState.Y(0), scoreBoxHeight, Math.PI/2, 0, true)
    screenState.canvasCtx.lineTo(scoreXpos,screenState.Y(0));
    screenState.canvasCtx.lineTo(scoreXpos,scoreYpos);
    screenState.canvasCtx.closePath();
    screenState.canvasCtx.fill();
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.moveTo(scoreXpos, scoreYpos);
    screenState.canvasCtx.lineTo(finalScoreWidth - scoreBoxHeight + screenState.offsetX, scoreYpos)
    screenState.canvasCtx.arc(finalScoreWidth - scoreBoxHeight, screenState.Y(0), scoreBoxHeight, Math.PI/2, 0, true);
    screenState.canvasCtx.stroke();

    // Combo box
    const comboBoxXpos = screenState.offsetX + screenState.width;
    // const comboBoxXpos2 = comboBoxXpos - finalComboWidth;
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.arc(comboBoxXpos, screenState.offsetY, comboBoxHeight, Math.PI*1.5, Math.PI/2, true);
    screenState.canvasCtx.lineTo(comboBoxXpos, screenState.offsetY);
    screenState.canvasCtx.closePath()
    screenState.canvasCtx.fill();

    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.arc(comboBoxXpos, screenState.offsetY, comboBoxHeight, Math.PI*1.5, Math.PI/2, true);
    screenState.canvasCtx.stroke();
    
    // screenState.canvasCtx.beginPath();
    // screenState.canvasCtx.moveTo(comboBoxXpos, screenState.offsetY);
    // screenState.canvasCtx.lineTo(comboBoxXpos2 - comboBoxHeight, screenState.offsetY);
    // screenState.canvasCtx.arc(comboBoxXpos2, screenState.offsetY, comboBoxHeight, Math.PI*1.5, Math.PI/2, true);
    // screenState.canvasCtx.lineTo(comboBoxXpos, screenState.offsetY + comboBoxHeight);
    // screenState.canvasCtx.lineTo(comboBoxXpos, screenState.offsetY);
    // screenState.canvasCtx.closePath()
    // screenState.canvasCtx.fill();

    // screenState.canvasCtx.beginPath();
    // screenState.canvasCtx.moveTo(comboBoxXpos2 - comboBoxHeight, screenState.offsetY);
    // screenState.canvasCtx.arc(comboBoxXpos2, screenState.offsetY, comboBoxHeight, Math.PI*1.5, Math.PI/2, true);
    // screenState.canvasCtx.lineTo(comboBoxXpos, screenState.offsetY + comboBoxHeight);
    // screenState.canvasCtx.stroke()


    // Scorebox Text
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.textAlign = 'center';
    screenState.canvasCtx.textBaseline = 'middle';
    screenState.canvasCtx.fillStyle = rgba(255,255,255, transitionProgress);
    screenState.canvasCtx.fillText(scoreText, finalScoreWidth/2.25 + screenState.offsetX, scoreBoxHeight/2 + screenState.offsetY);
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.font = `${screenState.S(30)}px Yusei Magic`
    screenState.canvasCtx.textAlign = 'left';
    screenState.canvasCtx.textBaseline = 'top';
    screenState.canvasCtx.fillText("Score", screenState.X(10), screenState.Y(10));

    // Combobox Text
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.textAlign = 'right'
    screenState.canvasCtx.fillText("Combo", comboBoxXpos - screenState.S(10), screenState.Y(10));
    screenState.canvasCtx.textAlign = 'center';
    screenState.canvasCtx.textBaseline = 'middle';
    screenState.canvasCtx.font = `${screenState.S(48)}px Yusei Magic`
    screenState.canvasCtx.fillText(comboText, comboBoxXpos - comboBoxHeight/2.25, screenState.offsetY + comboBoxHeight/2);
    
    // Progress Bar
    screenState.canvasCtx.globalAlpha = screenState.transitionProgress;
    screenState.canvasCtx.lineWidth = screenState.S(10);
    screenState.canvasCtx.strokeStyle = rgb(228, 255, 26);
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.moveTo(screenState.offsetX, screenState.offsetY);
    let progressWidth;
    if (timeSinceInit <= 3000){
      progressWidth = 0;
    }
    else{
      progressWidth = this.currentPlayerPosition ? screenState.offsetX + (screenState.width*Math.min(this.currentPlayerPosition/this.duration, 1)) : (timeSinceInit > 10000) ? screenState.offsetX + screenState.width : 0;
    }
    screenState.canvasCtx.lineTo(progressWidth, screenState.offsetY);
    screenState.canvasCtx.stroke();
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.moveTo(progressWidth, screenState.offsetY);
    screenState.canvasCtx.strokeStyle = rgb(149, 169, 0);
    screenState.canvasCtx.shadowColor = rgb(149, 169, 0);
    screenState.canvasCtx.lineTo(screenState.offsetX + screenState.width, screenState.offsetY);
    screenState.canvasCtx.stroke();

    screenState.canvasCtx.globalAlpha = 1;
    screenState.canvasCtx.shadowBlur = 0;
  }
}